import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight16 } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenuButton,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';

export type MoveGoalMenuItemProps = {
  onSelect: () => void;
  buttonRef?: (element: HTMLButtonElement | null) => void;
};

export const MoveGoalMenuItem: React.FC<MoveGoalMenuItemProps> = ({
  onSelect,
  buttonRef,
}) => {
  const { t } = useTranslation();

  const onMoveGoal = (e: React.MouseEvent) => {
    e.preventDefault();
    onSelect();
  };

  return (
    <PopupMenuListItem>
      <PopupMenuButton
        onClick={onMoveGoal}
        start={<Icon icon={ArrowRight16} />}
        ref={buttonRef}
      >
        {t('context-menus.goal.labels.move-goal')}
      </PopupMenuButton>
    </PopupMenuListItem>
  );
};
